import type { Database } from 'node-sqlite3-wasm';
import type { SymbolImportBinding, SymbolTag } from '../../types.js';
import { contentHashFileHasImports, contentHashFileHasTags } from './content-hash-check.js';
import { insertSymbolImportsForContent, insertSymbolTagsForContent } from './insert-symbol-content.js';
import { countParentFileMapRefs } from './parent-file-map.js';

export function upsertSymbolContentIndex(
  db: Database,
  contentHash: string,
  filePath: string,
  tags: readonly SymbolTag[],
  imports: readonly SymbolImportBinding[],
): void {
  if (tags.length > 0 && !contentHashFileHasTags(db, contentHash, filePath)) {
    insertSymbolTagsForContent(db, contentHash, filePath, tags);
  }
  if (imports.length > 0 && !contentHashFileHasImports(db, contentHash, filePath)) {
    insertSymbolImportsForContent(db, contentHash, filePath, imports);
  }
}

export function deleteSymbolContentIfUnreferenced(db: Database, contentHash: string): void {
  if (countParentFileMapRefs(db, contentHash) > 0) return;
  db.run('DELETE FROM symbol_index_tag WHERE content_hash = ?', [contentHash]);
  db.run('DELETE FROM symbol_index_import WHERE content_hash = ?', [contentHash]);
}
